module.exports = __webpack_public_path__ + "static/automation1-70dd5398b907f59503cfe32516d7a163.png";